import { debounce } from 'lodash';

import { search } from '@/api/ProgramApi';

import { buildSelectableProgram } from '@/utils/buildSelectable';

import { Selectable } from '@/components/selectBox/selectBox';

export function useProgramsSearch(searchFilters?: Record<string, unknown>) {
  const searchQuery = ref('');
  const isLoading = ref(false);
  const programOptions = ref<Selectable<number>[]>([]);

  const searchPrograms = debounce(async (query: string) => {
    const response = await search({
      filters: {
        ...searchFilters,
        search: query
      }
    });
    programOptions.value = response.map((program) =>
      buildSelectableProgram(program)
    ) as Selectable<number>[];

    isLoading.value = false;
  }, 300);

  function onQueryChange(query: string): void {
    isLoading.value = true;
    searchQuery.value = query;

    searchPrograms(query);
  }

  return {
    programOptions,
    isLoading,
    onQueryChange
  };
}
